module.exports = __webpack_public_path__ + "img/banner3.c8fe471b.png";